module.exports = __webpack_public_path__ + "img/68_41.d922e470.png";